export function b64ToUtf8(str: string | undefined) {
  if (!str) return;
  return decodeURIComponent(escape(window.atob(str)));
}

export const fileToBase64 = (data: any, fileType: any) => {
  return new Promise((resolve, reject) => {
    if (!data) return;
    const reader = new FileReader();
    let type;

    if (data.type.match("text")) type = "text";
    else if (data.type.match("image")) type = "image";
    else if (data.type.match("sheet")) type = "excel";
    else type = data.type;

    reader.onload = (e: any) => {
      const src = e.target.result;
      resolve(src);
    };

    if (type === fileType) reader.readAsDataURL(data);
    else reject(`Please choose a valid ${fileType} file`);
  });
};
